import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=0a877bcb&scoped=true&"
import script from "./SearchPanel.vue?vue&type=script&lang=js&"
export * from "./SearchPanel.vue?vue&type=script&lang=js&"
import style0 from "./SearchPanel.vue?vue&type=style&index=0&id=0a877bcb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a877bcb",
  null
  
)

export default component.exports
import {QList,QExpansionItem,QCard,QCardSection,QBtn,QRadio,QTooltip,QInput,QIcon,QItem,QItemSection,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QExpansionItem,QCard,QCardSection,QBtn,QRadio,QTooltip,QInput,QIcon,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
